// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashBoardImageUploadContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 12px;
}

.profileDropzoneContainer,
.editProfileDropZoneContainer {
    cursor: pointer;
}

.profileDropzoneContainer .filepicker {
    font-size: 16px;
    line-height: normal;
    font-weight: 400;
    color: var(--primary-link-foreground);
    min-height: unset;
    padding: 0;
    background-color: transparent;
    border: unset;
    font-family: var(--font-family-base);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
}

.editProfileDropZoneContainer {
    position: absolute;
    bottom: calc(0% + 3px);
    right: calc((100% / 2) - ((120px / 2) - 2px));
    z-index: 1;
}

.editProfileDropZoneContainer .filepicker {
    min-height: unset;
    padding: 0;
    background-color: transparent;
    border: unset;
    border-radius: 50%;
}

.profileDropzoneContainer .dz-message,
.editProfileDropZoneContainer .dz-message {
    display: none;
}

.profileDropzoneContainer .dz-hidden-input,
.editProfileDropZoneContainer .dz-hidden-input {
    z-index: -1;
}

.profileDropzoneContainer .filepicker img,
.editProfileDropZoneContainer .filepicker img {
    position: relative;
    z-index: -1;
}

.rtl .editProfileDropZoneContainer {
    right: unset;
    left: calc((100% / 2) - ((120px / 2) - 2px));
}`, "",{"version":3,"sources":["webpack://./src/styles/profileDropzone.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,qCAAqC;IACrC,iBAAiB;IACjB,UAAU;IACV,6BAA6B;IAC7B,aAAa;IACb,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,6CAA6C;IAC7C,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,6BAA6B;IAC7B,aAAa;IACb,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,4CAA4C;AAChD","sourcesContent":[".dashBoardImageUploadContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 12px;\n}\n\n.profileDropzoneContainer,\n.editProfileDropZoneContainer {\n    cursor: pointer;\n}\n\n.profileDropzoneContainer .filepicker {\n    font-size: 16px;\n    line-height: normal;\n    font-weight: 400;\n    color: var(--primary-link-foreground);\n    min-height: unset;\n    padding: 0;\n    background-color: transparent;\n    border: unset;\n    font-family: var(--font-family-base);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n}\n\n.editProfileDropZoneContainer {\n    position: absolute;\n    bottom: calc(0% + 3px);\n    right: calc((100% / 2) - ((120px / 2) - 2px));\n    z-index: 1;\n}\n\n.editProfileDropZoneContainer .filepicker {\n    min-height: unset;\n    padding: 0;\n    background-color: transparent;\n    border: unset;\n    border-radius: 50%;\n}\n\n.profileDropzoneContainer .dz-message,\n.editProfileDropZoneContainer .dz-message {\n    display: none;\n}\n\n.profileDropzoneContainer .dz-hidden-input,\n.editProfileDropZoneContainer .dz-hidden-input {\n    z-index: -1;\n}\n\n.profileDropzoneContainer .filepicker img,\n.editProfileDropZoneContainer .filepicker img {\n    position: relative;\n    z-index: -1;\n}\n\n.rtl .editProfileDropZoneContainer {\n    right: unset;\n    left: calc((100% / 2) - ((120px / 2) - 2px));\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
